import { PageLayout } from "@/components/PageLayout";
import { PricingSection } from "@/components/PricingSection";

export default function PricingPage() {
  return (
    <PageLayout>
      <section className="pt-28 lg:pt-32 pb-6 bg-gradient-to-br from-sky-50/60 via-white to-lime-50/40 text-center">
        <div className="max-w-3xl mx-auto px-5">
          <span className="inline-block text-sm font-semibold text-sky-600 tracking-wider uppercase mb-3">
            Pricing
          </span>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight mb-4">
            Transparent per-item pricing
          </h1>
          <p className="text-slate-500 leading-relaxed">
            The price you see is the price you pay. Free pickup and delivery across Jaipur — no hidden charges, no minimum order.
          </p>
        </div>
      </section>
      <PricingSection />
    </PageLayout>
  );
}
